module.exports = __webpack_public_path__ + "img/home.f52141e3.svg";